module.exports = __webpack_public_path__ + "img/ProtectingData.9010b3e2.jpg";